export const HOST = process.env.REACT_APP_API_URL || 'https://cdn-dev.kiemdinhoto.vn'
export const ZALO_HOST = 'http://zalo.ttdkapi.ttdk.com.vn'
export const IMAGE_HOST = HOST + 'upload/'
export const ALERT_SERVICE_FIRST_PAGE = '/automated-traffic-fine-notification/vehicles'
export const ALERT_SERVICE_SECOND_PAGE = '/automated-traffic-fine-notification/services'
export const ALERT_SERVICE_THIRD_PAGE = '/automated-traffic-fine-notification/payment'

const DEVELOP_URL = {
  REACT_APP_DOMAIN: 'ttdk-develop-web.service.makefamousapp.com',
  REACT_APP_URL_WEB_TTDK: 'https://ttdk-develop-web.service.makefamousapp.com',
  REACT_APP_URL_WEB_BAOHIEM: 'https://ttdk-develop-baohiem.service.makefamousapp.com',
  REACT_APP_URL_WEB_MINIAPP_DATLICH: 'https://ttdk-develop-partner.service.makefamousapp.com'
}
const PRODUCTION_URL = {
  REACT_APP_DOMAIN: 'ttdk.com.vn',
  REACT_APP_URL_WEB_TTDK: 'https://ttdk.com.vn',
  REACT_APP_URL_WEB_BAOHIEM: 'https://baohiem.ttdk.com.vn',
  REACT_APP_URL_WEB_MINIAPP_DATLICH: 'https://partner.ttdk.com.vn'
}
const REACT_APP_RUNTIME_MODE = process.env.REACT_APP_RUNTIME_MODE
const DEFAULT_URLS = REACT_APP_RUNTIME_MODE === 'developer' ? DEVELOP_URL : PRODUCTION_URL

export const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN || DEFAULT_URLS.REACT_APP_DOMAIN
export const REACT_APP_URL_WEB_TTDK = process.env.REACT_APP_URL_WEB_TTDK || DEFAULT_URLS.REACT_APP_URL_WEB_TTDK
export const REACT_APP_URL_WEB_BAOHIEM = process.env.REACT_APP_URL_WEB_BAOHIEM || DEFAULT_URLS.REACT_APP_URL_WEB_BAOHIEM
export const REACT_APP_URL_WEB_MINIAPP_DATLICH = process.env.REACT_APP_URL_WEB_MINIAPP_DATLICH || DEFAULT_URLS.REACT_APP_URL_WEB_MINIAPP_DATLICH
export const SALADIN_INSURANCE_URL = 'https://ttdk.partner.saladin.vn/mua-bao-hiem-o-to/thong-tin-xe'
export const HIDDEN_REDIRECT_ROUTE_PATHS = [
  '/kiemtraphatnguoi',
  ALERT_SERVICE_FIRST_PAGE,
  ALERT_SERVICE_SECOND_PAGE,
  ALERT_SERVICE_THIRD_PAGE
]

export const isHiddenRedirectRoutePath = (path = '') => {
  if (!path || typeof path !== 'string') {
    return false
  }

  return HIDDEN_REDIRECT_ROUTE_PATHS.includes(path.split('?')[0])
}

export const isSaladinInsuranceLink = (path = '') => {
  if (!path || typeof path !== 'string') {
    return false
  }

  let normalizedPath = path

  try {
    normalizedPath = decodeURIComponent(path)
  } catch (error) {}

  return normalizedPath.startsWith(SALADIN_INSURANCE_URL) || normalizedPath.includes(`redirect=${SALADIN_INSURANCE_URL}`)
}
